module.exports = __webpack_public_path__ + "static/img/2.04a5698.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/eng/2.png
// module id = v8AW
// module chunks = 0